import { render, staticRenderFns } from "./course_wrong.vue?vue&type=template&id=f21e6cb0&scoped=true&"
import script from "./course_wrong.vue?vue&type=script&lang=js&"
export * from "./course_wrong.vue?vue&type=script&lang=js&"
import style0 from "./course_wrong.vue?vue&type=style&index=0&id=f21e6cb0&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f21e6cb0",
  null
  
)

export default component.exports